export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 40 40" className={`${className} text-electric`} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 10C8 8.89543 8.89543 8 10 8H22C27.5228 8 32 12.4772 32 18C32 23.5228 27.5228 28 22 28H10C8.89543 28 8 27.1046 8 26V10Z"
      opacity="0.2"
      className="fill-current"
    />
    <path
      d="M12 12H20C23.3137 12 26 14.6863 26 18C26 21.3137 23.3137 24 20 24H12V12Z"
      stroke="currentColor"
      strokeWidth="2.5"
      fill="none"
    />
    <circle cx="20" cy="18" r="3" fill="#38BDF8" />
    <path d="M26 12L32 8V28L26 24V12Z" fill="#2563EB" />
  </svg>
);

export const Logo = ({ light = true }) => (
  <span className="flex items-center gap-2.5 select-none">
    <LogoMark />
    <span className="flex flex-col leading-none">
      <span
        className={`font-display font-bold tracking-tight text-lg ${
          light ? "text-white" : "text-ink"
        }`}
      >
        CINEBLUE
      </span>
      <span className="font-mono text-[9px] tracking-[0.35em] text-electric uppercase">
        Executive
      </span>
    </span>
  </span>
);

export default Logo;
